<template>
  <div class="page page-sidri p-bottom-xxxl-1">
    <PagesHomeHero v-if="page?.hero" :hero="page.hero" />

    <!-- Body -->
    <template v-if="page?.body && page.body?.length">
      <PagesCommonBody :body-items="page.body" :touch="touch" />
    </template>

    <!-- Products grid -->
    <section v-if="listingProducts?.length">
      <PagesCommonProductsGrid :products="listingProducts" /> 
    </section>
  </div>
</template>

<script setup>
import queries from '@/graphql/dato/queries/index.js'
import pageTransition from '@/assets/js/transitions/helper.js'

definePageMeta({
  layout: 'default',
  pageTransition,
})

const { locale } = useI18n()

const touch = ref(false)

const query = queries.ciders.getCiders
const variables = computed(() => ({
  locale: locale?.value ? locale.value : 'it',
}))

const { data } = await useGraphql(query, variables)

if (!data.value?.cidersPage) {
  throw createError({ statusCode: 404 })
}

onMounted(() => {
  touch.value = 'ontouchstart' in window || !!navigator.maxTouchPoints /// !! trasformano 0/1 in Bool
})

const page = computed(() => data?.value?.cidersPage)
const listingProducts = computed(() => {
  const totalArray = data?.value?.allProducts || []
  const validListingProducts = totalArray.filter((product) => product.listingImage && product.listingExtract)
  return validListingProducts
})
const seo = computed(() => data?.value?.cidersPage?.seo || {})

// Seo
useSeo({
  ...seo.value,
})
</script>
